import CodeServiceModel from '@/models/CodeServiceModel';
import doc              from '@widesk-core/decorators/doc';
import model            from '@widesk-core/decorators/model';

export type Code_CodePropertyReference = (
	'owner_lastname'
	| 'owner_firstname'
	| 'owner_email'
	| 'owner_photo'
	| 'owner_birthdate'
	| 'number'
	| 'firstname'
	| 'lastname'
	| 'email'
	| 'photo_url'
	);

@model.urnResource('code_property')
@doc.path('/code_properties/{?id}')
export default class CodePropertyModel extends CodeServiceModel {
	private declare _tsFilters: {
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'reference': Code_CodePropertyReference;
		'service': id;
		'service.serviceUrn': Urn;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'id': string;
		'reference': string;
	};

	@doc.string declare reference: Code_CodePropertyReference;
}
